import { useRef, useState } from "react";
import { FileText, UploadCloud, X } from "lucide-react";

export const FileDrop = ({ files, setFiles }) => {
  const input = useRef(null);
  const [drag, setDrag] = useState(false);
  const add = (list) => setFiles((prev) => [...prev, ...Array.from(list)].slice(0, 10));

  return (
    <div>
      <div
        role="button"
        tabIndex={0}
        data-testid="estimate-file-dropzone"
        onClick={() => input.current?.click()}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && input.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); add(e.dataTransfer.files); }}
        className={`flex cursor-pointer flex-col items-center justify-center gap-2 border border-dashed px-6 py-8 text-center transition-colors duration-300 ${drag ? "border-[#CDA85B] bg-[#CDA85B]/10" : "border-white/20 hover:border-[#CDA85B]/60"}`}
      >
        <UploadCloud className="h-7 w-7 text-[#CDA85B]" strokeWidth={1.3} />
        <span className="text-sm text-[#ECE6DA]">Drop photos or drawings here, or <span className="text-[#CDA85B] underline underline-offset-4">browse</span></span>
        <span className="text-xs text-[#AEB3BC]">JPG, PNG, HEIC or PDF · up to 10 files · 15MB each</span>
        <input ref={input} type="file" multiple accept="image/*,.pdf" className="hidden" data-testid="estimate-file-input" onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
      </div>
      {files.length > 0 && (
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-testid="estimate-file-list">
          {files.map((f, i) => (
            <li key={`${f.name}-${i}`} className="flex items-center justify-between gap-2 bg-white/[0.04] px-3 py-2 text-xs text-[#ECE6DA]">
              <span className="flex min-w-0 items-center gap-2"><FileText className="h-4 w-4 shrink-0 text-[#CDA85B]" /><span className="truncate">{f.name}</span></span>
              <button type="button" aria-label={`Remove ${f.name}`} data-testid={`estimate-file-remove-${i}`} onClick={() => setFiles((p) => p.filter((_, k) => k !== i))}><X className="h-4 w-4 text-[#AEB3BC] hover:text-white" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
